import { useCallback, useEffect, useRef } from "react";

const useIframeMessageHandler = ({ iframeUrl, iframeRef, billingPageUrl, onClose }) => {
  const stateRef = useRef({ iframeUrl, billingPageUrl, onClose });
  stateRef.current = { iframeUrl, billingPageUrl, onClose };

  const handleIframeMessage = useCallback(
    (event) => {
      const { iframeUrl: url, billingPageUrl: billing, onClose: close } = stateRef.current;
      if (!url) return;

      let expectedOrigin;
      try {
        expectedOrigin = new URL(url).origin;
      } catch {
        return;
      }

      if (event.origin !== expectedOrigin) return;

      switch (event.data?.type) {
        case "CARD_APP_READY":
          if (iframeRef.current && billing) {
            iframeRef.current.contentWindow.postMessage(
              {
                type: "COMPOSE_DATA",
                data: { billing_page_url: billing },
              },
              expectedOrigin,
            );
          }
          break;
        case "CLOSE_CLICK":
        case "CANCEL_CLICK":
          close();
          break;
        default:
          break;
      }
    },
    [iframeRef],
  );

  useEffect(() => {
    if (iframeUrl) {
      window.addEventListener("message", handleIframeMessage);
      return () => window.removeEventListener("message", handleIframeMessage);
    }
    return undefined;
  }, [iframeUrl, handleIframeMessage]);
};

export default useIframeMessageHandler;
